/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-07-15 17:58:33
 * @LastEditors: linwc
 * @LastEditTime: 2025-08-13 14:10:56
 */
// import { colors_light } from '@/theme/colors_light.js';

// const defaultList = [];

// for (const key in colors_light) {
//   const item = colors_light[key];
//   defaultList.push(`--${key}:${item}`);
// }

// let defaultStyle = defaultList.join(';');

export default {
  namespaced: true, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state: {
    // skin: defaultStyle
    skin: {}
  },
  actions: {},
  mutations: {
    setSkin(state, skin) {
      // let list = [];
      // for (const key in skin) {
      //   const item = skin[key];
      //   list.push(`--${key}:${item}`);
      // }
      // let style = list.join(';');
      // state.skin = style;
      // // app 换肤
      // document.getElementsByTagName('body')[0].setAttribute('style', style);
    }
  }
};
